import { render, staticRenderFns } from "./ValueBoxesContainer.vue?vue&type=template&id=5f880d78&scoped=true"
import script from "./ValueBoxesContainer.vue?vue&type=script&lang=js"
export * from "./ValueBoxesContainer.vue?vue&type=script&lang=js"
import style0 from "./ValueBoxesContainer.vue?vue&type=style&index=0&id=5f880d78&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5f880d78",
  null
  
)

export default component.exports